import { Container } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ConcealableContainer from 'src/components/ConcealableContainer';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import Todos from './Todos';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function UyariMerkezi() {
  const classes = useStyles();
  const { t } = useTranslation('warning_center');
  const SessionUser = getUser();
  var TitleApp = "Sirius Partner";
  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="lg">
        <Header />
        <Todos className={classes.todos} />
        <ConcealableContainer show>
          <Alert severity="warning">{t('alert_message')}</Alert>
        </ConcealableContainer>
      </Container>
    </Page>
  );
}

export default UyariMerkezi;
